import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Snackbar as MuiSnackbar, Alert, IconButton, styled, } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Button from '../Button';
/**
 *
 * to disable autohide, set `duration` to `null` (defaults to 5000)
 */
export const Snackbar = ({ isOpen, positionVertical = 'top', positionHorizontal = 'center', message = '', actionText = undefined, onClickAction = () => { }, onClose = undefined, severity = undefined, duration, sx = {}, }) => {
    let customDuration = duration;
    // Inspired by: https://ux.stackexchange.com/questions/11203/how-long-should-a-temporary-notification-toast-appear/85898#85898
    if (duration === undefined) {
        customDuration = Math.min(Math.max(message.length * 65, 2000), 8000);
    }
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        onClose?.(event, reason);
    };
    const action = (_jsxs(_Fragment, { children: [actionText ? (_jsx(Button, { label: actionText, onClick: onClickAction, variant: 'text', color: 'inherit' })) : null, _jsx(IconButton, { size: 'small', "aria-label": 'close', color: 'inherit', onClick: handleClose, children: _jsx(CloseIcon, { fontSize: 'small' }) })] }));
    if (severity) {
        const FullWidthAlert = styled(Alert) `
      min-width: 288px;
      align-items: center;
      .MuiAlert-action {
        align-items: center;
        padding-top: 0;
      }
    `;
        let severityMessage = message;
        let severityDuration = customDuration;
        if (!message && severity === 'error') {
            severityMessage = 'Something went wrong. Try again or contact support.';
            severityDuration = 5000;
        }
        ;
        return (_jsx(MuiSnackbar, { open: isOpen, anchorOrigin: {
                vertical: positionVertical,
                horizontal: positionHorizontal,
            }, onClose: handleClose, autoHideDuration: severityDuration, sx: { ...sx, maxWidth: 500 }, children: _jsx(FullWidthAlert, { variant: 'filled', severity: severity, action: action, elevation: 6, children: severityMessage }) }));
    }
    return (_jsx(MuiSnackbar, { open: isOpen, anchorOrigin: {
            vertical: positionVertical,
            horizontal: positionHorizontal,
        }, message: message, action: action, onClose: handleClose, autoHideDuration: customDuration, sx: { ...sx, maxWidth: 600 } }));
};
//# sourceMappingURL=index.js.map